class GaiaModal extends HTMLElement {
  constructor() {
    super();

    this.content = this.querySelector(".modal-content");
    this.addEventListener("focusout", (e) => this.clickOff(e).bind(this));
    this.closeButton = this.querySelector(".modal-close");
    this.closeButton.addEventListener("click", this.closeModal.bind(this));
  }

  clickOff(e) {
    setTimeout(() => {
      if (
        !this.contains(document.activeElement) &&
        e.srcElement.tagName != "SELECT"
      )
        this.closeModal();
    });
  }

  openModal(productHandle) {
    if (!productHandle) return;
    document.querySelector("cart-drawer").close();
    this.setAttribute("open", "");
    this.setAttribute("loading", "");
    this.style.height = `${this.getBoundingClientRect().height}px`;
    this.fetchContent(productHandle);
    document.body.classList.add("overflow-hidden");

    // Klaviyo tracking
    const observer = new MutationObserver((mutationsList, observer) => {
      for (let mutation of mutationsList) {
        if (mutation.type === "childList") {
          const button = this.querySelector(".product-form__submit");
          // When button exists
          if (button) {
            button.addEventListener("click", (e) => {
              // Grab tracking div to feed data to Klavyio
              const trackingDiv = this.querySelector(
                ".product-details-tracking"
              );
              // Get data
              const productName = trackingDiv.getAttribute("data-Name");
              const productId = trackingDiv.getAttribute("data-ProductID");
              const imageUrl = trackingDiv.getAttribute("data-ImageUrl");
              const price = trackingDiv.getAttribute("data-Price");
              const url = trackingDiv.getAttribute("data-URL");
              const compareAtPrice = trackingDiv.getAttribute(
                "data-CompareAtPrice"
              );
              const brand = trackingDiv.getAttribute("data-Brand");
              // Push data to Klaviyo
              window._learnq.push([
                "track",
                "Added to Cart",
                {
                  Name: productName,
                  ProductID: productId,
                  ImageURL: imageUrl,
                  URL: url,
                  Brand: brand,
                  Price: price,
                  CompareAtPrice: compareAtPrice,
                },
              ]);
            });
          }
        }
      }
    });
    // Waiting for button to exist before listening for click event
    observer.observe(this, { childList: true, subtree: true });
  }

  closeModal() {
    this.removeAttribute("open");
    document.body.classList.remove("overflow-hidden");
    setTimeout(() => {
      this.content.innerHTML = "";
      this.style.height = "";
    }, 300);
  }

  fetchContent(productHandle) {
    const url = `${window.location.origin}/products/${productHandle}?sections=gaia-modal`;

    fetch(url)
      .then((response) => response.json())
      .then((sections) => {
        const parser = new DOMParser();
        this.content.innerHTML = parser
          .parseFromString(sections["gaia-modal"], "text/html")
          .querySelector("gaia-modal .modal-content").innerHTML;
        this.removeAttribute("loading");
        this.focus();
        this.initSwiper();
        this.gallery = this.content.querySelector(".modal-content img");
        this.details = this.content.querySelector(".product-details");
        this.style.height = `calc(${Math.max(
          this.gallery.getBoundingClientRect().height,
          this.details.getBoundingClientRect().height
        )}px + (2 * var(--quick-buy-modal-pad)))`;
      })
      .catch((e) => {
        console.error(e);
      });
  }

  initSwiper() {
    var swiper_thumbs = new Swiper(this.querySelector(".thumbnails"), {
      spaceBetween: parseInt(
        getComputedStyle(document.documentElement).getPropertyValue(
          "--spacing-300"
        )
      ),
      slidesPerView: 3,
      watchSlidesProgress: true,
    });

    var swiper = new Swiper(this.querySelector(".images.swiper-enabled"), {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      thumbs: {
        swiper: swiper_thumbs,
      },
      keyboard: {
        enabled: true,
      },
      initialSlide: this.querySelector(
        "variant-selects, variant-radios"
      )?.updateMedia(),
      loop: true,
    });
  }
}

customElements.define("gaia-modal", GaiaModal);

function openModal(event, productHandle) {
  event.preventDefault();
  document.querySelector("gaia-modal").openModal(productHandle);
}
